var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.searchResults)?_c('div',{staticClass:"px-4 pb-4 border-top pt-4"},[_c('SongResults')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }